export const filterField = [
  {
    title: "HMPPS Area",
    name: "regions_data",
  },
  {
    title: "Prisons",
    name: "prisons_data",
  },
  {
    title: "Probation Regions",
    name: "probation_regions_data",
  },
  {
    title: "Area Covered",
    name: "area_covered_data",
  },
  {
    title: "Type of Organisation",
    name: "type_of_organisation_data",
  },
  {
    title: "Custody or Community",
    name: "custody_or_community_data",
  },
  // {
  //   title: "Racial Equity Specialist",
  //   name: "racially_minoritised_data",
  // },
  {
    title: "Specialist Organisation",
    name: "specialist_organisation_data",
  },
  {
    title: "County",
    name: "county_data",
  },
];
